// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__2XesA","col":"CardReaderDesc_col__3RBhu","label":"CardReaderDesc_label__20Err"};